// Fallback for using MaterialIcons on Android and web.

import MaterialIcons from "@expo/vector-icons/MaterialIcons";
import { SymbolWeight, SymbolViewProps } from "expo-symbols";
import { ComponentProps } from "react";
import { OpaqueColorValue, type StyleProp, type TextStyle } from "react-native";

type IconMapping = Record<string, ComponentProps<typeof MaterialIcons>["name"]>;
type IconSymbolName = string;

/**
 * Add your SF Symbols to Material Icons mappings here.
 * - see Material Icons in the [Icons Directory](https://icons.expo.fyi).
 * - see SF Symbols in the [SF Symbols](https://developer.apple.com/sf-symbols/) app.
 */
const MAPPING = {
  "house.fill": "home",
  "paperplane.fill": "send",
  "chevron.left.forwardslash.chevron.right": "code",
  "chevron.right": "chevron-right",
  "camera.fill": "photo-camera",
  "list.bullet": "list",
  "book.closed.fill": "auto-stories",
  "book.pages.fill": "auto-stories",
  "photo.stack.fill": "perm-media",
  "person.3.fill": "group",
  "person.fill": "person",
  "photo.fill": "photo",
  "play.rectangle.fill": "perm-media",
  "gear": "settings",
  "lock.fill": "lock",
  "exclamationmark.triangle.fill": "warning",
  "paintpalette.fill": "palette",
  "share.fill": "share",
  "textformat.size": "text-fields",
  "slider.horizontal.3": "tune",
  "bubble.left.and.bubble.right.fill": "chat",
  "message.fill": "chat",
  "checkmark": "check",
  "calendar": "calendar-today",
  "clock.fill": "history",
  "waveform.path.ecg": "timeline",
  "location.fill": "place",
  "location": "place",
  "anchor": "anchor",
} as IconMapping;

/**
 * An icon component that uses native SF Symbols on iOS, and Material Icons on Android and web.
 * This ensures a consistent look across platforms, and optimal resource usage.
 * Icon `name`s are based on SF Symbols and require manual mapping to Material Icons.
 * @param root0
 * @param root0.name
 * @param root0.size
 * @param root0.color
 * @param root0.style
 * @param root0.weight
 */
export function IconSymbol({ name, size = 24, color, style }: { name: string; size?: number; color: string | OpaqueColorValue; style?: StyleProp<TextStyle>; weight?: SymbolWeight }) {
  return <MaterialIcons color={color} size={size} name={MAPPING[name]} style={style} />;
}
